import { useState } from 'react';
import { Plus, X, Check, Star, Mail, Send, FileText, Building, Loader2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { toast } from 'sonner';
import { API } from './constants';

export function CrmConfig({ catalogue, onSave }) {
  const [cat, setCat] = useState(catalogue || {});
  const [saving, setSaving] = useState(false);
  const [newFormule, setNewFormule] = useState({ nom: '', prix: '', desc: '' });
  const [sendingDocs, setSendingDocs] = useState(false);
  const [docEmail, setDocEmail] = useState('lemas66250@gmail.com');
  const [sendCarte, setSendCarte] = useState(true);
  const [sendMenu, setSendMenu] = useState(true);
  const [docSender, setDocSender] = useState('restaurant');

  const handleSendDocs = async () => {
    if (!docEmail.trim()) { toast.error('Email requis'); return; }
    if (!sendCarte && !sendMenu) { toast.error('Selectionnez au moins un document'); return; }
    setSendingDocs(true);
    try {
      const res = await fetch(`${API}/api/crm/send-carte-menu`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ to: docEmail, carte: sendCarte, menu: sendMenu, sender: docSender }),
      });
      const data = await res.json();
      if (res.ok) { toast.success(data.message); }
      else { toast.error(data.detail || 'Erreur envoi'); }
    } catch { toast.error('Erreur envoi'); }
    setSendingDocs(false);
  };

  const save = async (updates) => {
    setSaving(true);
    const merged = { ...cat, ...updates };
    try {
      await fetch(`${API}/api/crm/catalogue`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(merged) });
      setCat(merged); onSave(merged); toast.success('Catalogue sauvegarde');
    } catch { toast.error('Erreur'); }
    setSaving(false);
  };

  const addFormule = () => {
    if (!newFormule.nom || !newFormule.prix) return;
    const formules = [...(cat.formules || []), { ...newFormule, prix: Number(newFormule.prix) }];
    save({ formules }); setCat(prev => ({ ...prev, formules }));
    setNewFormule({ nom: '', prix: '', desc: '' });
  };

  const removeFormule = (idx) => {
    const formules = (cat.formules || []).filter((_, i) => i !== idx);
    save({ formules }); setCat(prev => ({ ...prev, formules }));
  };

  return (
    <div className="space-y-4" data-testid="crm-config">
      <div className="bg-white rounded-xl border p-4 space-y-3">
        <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wider flex items-center gap-2"><Building size={14} /> Informations restaurant</h3>
        <div className="grid grid-cols-2 gap-3">
          {[
            { label: 'Nom restaurant', key: 'restaurant_nom' },
            { label: 'Tel restaurant', key: 'restaurant_tel' },
            { label: 'Email restaurant', key: 'restaurant_email' },
            { label: 'Adresse', key: 'restaurant_adresse' },
            { label: 'Site web', key: 'restaurant_site' },
            { label: 'Nom patron', key: 'patron_nom' },
            { label: 'Tel patron', key: 'patron_tel' },
          ].map(f => (
            <div key={f.key}><label className="text-[10px] text-gray-400 block mb-0.5">{f.label}</label>
              <Input value={cat[f.key] || ''} onChange={e => setCat(prev => ({ ...prev, [f.key]: e.target.value }))}
                onBlur={() => save({ [f.key]: cat[f.key] })} className="text-xs h-8" /></div>
          ))}
        </div>
        <div><label className="text-[10px] text-gray-400 block mb-0.5">Slogan / Accroche</label>
          <Input value={cat.restaurant_slogan || ''} onChange={e => setCat(prev => ({ ...prev, restaurant_slogan: e.target.value }))}
            onBlur={() => save({ restaurant_slogan: cat.restaurant_slogan })} className="text-xs h-8" /></div>
      </div>

      <div className="bg-white rounded-xl border p-4 space-y-3">
        <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wider flex items-center gap-2"><FileText size={14} /> Formules & Tarifs</h3>
        <p className="text-[10px] text-gray-400">Ces formules sont injectees dans les templates emails et scripts d'appel</p>
        <div className="space-y-1.5">
          {(cat.formules || []).map((f, i) => (
            <div key={i} className="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2"><span className="text-xs font-bold text-gray-900">{f.nom}</span><span className="text-xs font-mono text-[#C9A84C] font-bold">{f.prix}EUR/pers.</span></div>
                <p className="text-[10px] text-gray-500">{f.desc}</p>
              </div>
              <button onClick={() => removeFormule(i)} className="text-gray-300 hover:text-red-500 ml-2"><X size={14} /></button>
            </div>
          ))}
        </div>
        <div className="flex gap-2 items-end">
          <div className="flex-1"><label className="text-[10px] text-gray-400 block mb-0.5">Nom formule</label><Input value={newFormule.nom} onChange={e => setNewFormule(p => ({ ...p, nom: e.target.value }))} placeholder="Menu Groupe..." className="text-xs h-8" /></div>
          <div className="w-20"><label className="text-[10px] text-gray-400 block mb-0.5">Prix EUR</label><Input type="number" value={newFormule.prix} onChange={e => setNewFormule(p => ({ ...p, prix: e.target.value }))} className="text-xs h-8 font-mono" /></div>
          <Button onClick={addFormule} size="sm" className="bg-[#009893] text-white h-8"><Plus size={14} /></Button>
        </div>
        <div><label className="text-[10px] text-gray-400 block mb-0.5">Description</label>
          <Input value={newFormule.desc} onChange={e => setNewFormule(p => ({ ...p, desc: e.target.value }))} placeholder="Entree + Plat + Dessert..." className="text-xs h-8" /></div>
      </div>

      <div className="bg-white rounded-xl border p-4 space-y-3">
        <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wider flex items-center gap-2"><Star size={14} /> Points forts</h3>
        <div className="space-y-1">
          {(cat.points_forts || []).map((pf, i) => (
            <div key={i} className="flex items-center gap-2 text-xs text-gray-700"><Check size={12} className="text-green-500 shrink-0" /><span>{pf}</span></div>
          ))}
        </div>
      </div>

      <div className="bg-gradient-to-r from-[#1B2A52]/5 to-transparent rounded-xl p-4">
        <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wider flex items-center gap-2 mb-2"><Mail size={14} /> Apercu signature email</h3>
        <div className="bg-white rounded-lg border p-3">
          <p className="text-sm font-bold text-[#1B2A52]">{cat.patron_nom || 'Laurent San Martin'}</p>
          <p className="text-[10px] text-[#C9A84C] uppercase tracking-wider">{cat.restaurant_nom || 'Le Mas'}</p>
          <p className="text-[10px] text-gray-400">Restaurant & Traiteur</p>
          <div className="mt-2 space-y-0.5 text-[10px] text-gray-500">
            <p>Tel: {cat.patron_tel || '06 87 88 59 25'}</p>
            <p>Fix: {cat.restaurant_tel || '04 68 38 06 98'}</p>
            <p>{cat.restaurant_email || 'contact@restaurant-le-mas.fr'}</p>
            <p>{cat.restaurant_site || 'www.restaurant-le-mas.fr'}</p>
            <p className="text-gray-300">{cat.restaurant_adresse || 'Saint-Laurent-de-la-Salanque'}</p>
          </div>
          <p className="text-[10px] text-gray-300 italic mt-2 border-t pt-2">{cat.restaurant_slogan || ''}</p>
        </div>
      </div>

      <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl p-4 space-y-3" data-testid="send-carte-menu">
        <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wider flex items-center gap-2"><Send size={14} className="text-green-600" /> Envoyer Carte & Menu par email</h3>
        <p className="text-[10px] text-gray-500">Envoyez la carte du restaurant et/ou le menu du jour en PDF par email</p>
        <div>
          <label className="text-[10px] text-gray-400 block mb-0.5">Destinataire</label>
          <Input value={docEmail} onChange={e => setDocEmail(e.target.value)} placeholder="email@exemple.com" className="text-xs h-8" data-testid="doc-email-input" />
        </div>
        <div className="flex gap-4">
          <label className="flex items-center gap-2 text-xs text-gray-700 cursor-pointer">
            <input type="checkbox" checked={sendCarte} onChange={e => setSendCarte(e.target.checked)} className="rounded border-gray-300 text-[#009893]" />
            Carte du restaurant (PDF)
          </label>
          <label className="flex items-center gap-2 text-xs text-gray-700 cursor-pointer">
            <input type="checkbox" checked={sendMenu} onChange={e => setSendMenu(e.target.checked)} className="rounded border-gray-300 text-[#009893]" />
            Menu du jour (PDF)
          </label>
        </div>
        <div>
          <label className="text-[10px] text-gray-400 block mb-0.5">Expediteur</label>
          <select value={docSender} onChange={e => setDocSender(e.target.value)} className="w-full border rounded-lg px-2 py-1.5 text-xs bg-white h-8">
            <option value="restaurant">Email Restaurant</option>
            <option value="traiteur">Email Traiteur</option>
          </select>
        </div>
        <Button onClick={handleSendDocs} disabled={sendingDocs || (!sendCarte && !sendMenu)} className="w-full bg-green-600 hover:bg-green-700 text-white" data-testid="send-docs-btn">
          {sendingDocs ? <><Loader2 size={14} className="animate-spin mr-2" /> Envoi en cours...</> : <><Send size={14} className="mr-2" /> Envoyer</>}
        </Button>
      </div>
    </div>
  );
}
